import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = {
  id: "main",
  class: "sec-main"
}
const _hoisted_2 = { class: "accelerator-main pb-0" }
const _hoisted_3 = { class: "container-lg" }
const _hoisted_4 = { class: "col-sm-10 mx-auto" }
const _hoisted_5 = {
  style: {"--bs-breadcrumb-divider":"'>'"},
  "aria-label": "breadcrumb"
}
const _hoisted_6 = { class: "breadcrumb" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("li", {
  class: "breadcrumb-item active",
  "aria-current": "page"
}, "資源搜尋 - 政府資源總覽", -1)
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-sm-10 mx-auto" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "h2 text-primary mb-4" }, "政府資源總覽", -1)
const _hoisted_12 = { class: "select-filter border" }
const _hoisted_13 = { class: "select-filter-wrapper py-md-5 p-4" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-sm-6 col-xl mb-xl-0 mb-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "h3 form-label" }, "地區", -1)
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "col-sm-6 col-xl mb-xl-0 mb-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "h3 form-label" }, "功能屬性", -1)
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "col-sm-6 col-xl mb-xl-0 mb-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "h3 form-label" }, "創業階段", -1)
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "col col-xl-auto d-flex justify-content-center align-self-xl-end my-md-1" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-sm-10 mx-auto" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "h2 text-primary mb-4" }, "政府資源列表", -1)
const _hoisted_28 = { class: "lists-group" }
const _hoisted_29 = { class: "frsb mb-2" }
const _hoisted_30 = { class: "h3 me-5 me-md-3 flex-grow-1" }
const _hoisted_31 = { class: "tag btn-primay active flex-shrink-0 px-4 py-md-0 py-1" }
const _hoisted_32 = { class: "h5 w-85 d-none d-md-block multiline-ellipsis" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "text-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "link-anchor"
  }, "詳細內容")
], -1)
const _hoisted_34 = { class: "row mt-0" }
const _hoisted_35 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_pagination_component = _resolveComponent("pagination-component")!
  const _directive_title = _resolveDirective("title")!

  return _withDirectives((_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("nav", _hoisted_5, [
            _createElementVNode("ol", _hoisted_6, [
              _createElementVNode("li", _hoisted_7, [
                _createVNode(_component_router_link, {
                  to: "/",
                  title: "首頁",
                  class: "foo: false"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("首頁")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_8
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("form", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.location) = $event))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (item, key) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item,
                          value: key
                        }, _toDisplayString(item), 9, _hoisted_17))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.searchForm.location]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchForm.type) = $event))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (item, key) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item,
                          value: key
                        }, _toDisplayString(item), 9, _hoisted_20))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.searchForm.type]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchForm.stage) = $event))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stages, (item, key) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item,
                          value: key
                        }, _toDisplayString(item), 9, _hoisted_23))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.searchForm.stage]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("button", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.gets(_ctx.searchForm))),
                      type: "button",
                      class: "btn-primay filled"
                    }, "查詢")
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "list-card mb-md-3 mb-2"
                }, [
                  _createVNode(_component_router_link, {
                    to: {name: 'resources-detail', params: { id: item.id }},
                    title: "政府資源列表",
                    class: "foo: false"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, _toDisplayString(item.name), 1),
                        _createElementVNode("div", _hoisted_31, _toDisplayString(item.location.message), 1)
                      ]),
                      _createElementVNode("div", _hoisted_32, _toDisplayString(item.description), 1),
                      _hoisted_33
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createVNode(_component_pagination_component, {
              class: "pagination-component",
              totalPages: _ctx.totalPages,
              onOnClick: _ctx.changePage
            }, null, 8, ["totalPages", "onOnClick"])
          ])
        ])
      ])
    ])
  ])), [
    [_directive_title, '政府資源總覽']
  ])
}